module.exports = __webpack_public_path__ + "static/media/index.74b961a5.scss";


//////////////////
// WEBPACK FOOTER
// ./src/index.scss
// module id = 247
// module chunks = 0